module.exports = __webpack_public_path__ + "static/media/canari_music.e845ff96.png";